import { Logger } from '@quickplay/foundation';

export class YospaceLogger {
  static logger: Logger;

  static setLogger(logger: Logger): void {
    YospaceLogger.logger = logger;
  }

  static debug(msg: string): void {
    YospaceLogger.logger.debug(msg);
  }
  static error(msg: string): void {
    YospaceLogger.logger.error(msg);
  }
  static info(msg: string): void {
    YospaceLogger.logger.info(msg);
  }
  static trace(msg: string): void {
    YospaceLogger.logger.log(msg);
  }
  static warn(msg: string): void {
    YospaceLogger.logger.warn(msg);
  }
}
